import { useState } from "react";
import { Dog, Cat, Bird, Fish, Rabbit, Turtle, Squirrel, Snail } from "lucide-react";
import { speakBoth } from "@/lib/buddy";
import { tone, NOTE } from "@/lib/babySound";

export const ANIMALS = [
  { id: "dog", Icon: Dog, en: "Dog", es: "Perro", say: "Woof woof!", color: "#F2C94C" },
  { id: "cat", Icon: Cat, en: "Cat", es: "Gato", say: "Meow!", color: "#F28C38" },
  { id: "bird", Icon: Bird, en: "Bird", es: "Pájaro", say: "Tweet tweet!", color: "#6BB3E0" },
  { id: "fish", Icon: Fish, en: "Fish", es: "Pez", say: "Blub blub!", color: "#5AC8C8" },
  { id: "bunny", Icon: Rabbit, en: "Bunny", es: "Conejo", say: "Hop hop!", color: "#E58FB8" },
  { id: "turtle", Icon: Turtle, en: "Turtle", es: "Tortuga", say: "Slow and steady!", color: "#9BD08A" },
  { id: "squirrel", Icon: Squirrel, en: "Squirrel", es: "Ardilla", say: "Chitter chatter!", color: "#C8955A" },
  { id: "snail", Icon: Snail, en: "Snail", es: "Caracol", say: "Slide, slide!", color: "#A68BE0" },
];

export const AnimalSounds = ({ voice }) => {
  const [hot, setHot] = useState(null);
  const tap = (a) => {
    setHot(a.id); tone(NOTE.E5, 0.25, { vol: 0.12 });
    speakBoth(`${a.say} ${a.en}!`, a.es.toLowerCase(), voice).catch(() => {});
    setTimeout(() => setHot((h) => (h === a.id ? null : h)), 2600);
  };
  return (
    <div className="absolute inset-0 grid grid-cols-2 sm:grid-cols-4 gap-4 p-6 pt-24 bg-[#FFF8EC]" data-testid="game-animals">
      {ANIMALS.map((a) => (
        <button key={a.id} onPointerDown={() => tap(a)} data-testid={`animal-${a.id}`} aria-label={a.en}
          className={`rounded-[2rem] flex flex-col items-center justify-center gap-2 transition-transform duration-300 ${hot === a.id ? "scale-110 baby-wiggle" : ""}`} style={{ background: `${a.color}33`, border: `4px solid ${a.color}` }}>
          <a.Icon className="w-20 h-20 sm:w-24 sm:h-24" style={{ color: a.color }} strokeWidth={1.6} />
          <span className="font-display text-2xl text-[#2C4A3E]">{hot === a.id ? a.es : a.en}</span>
        </button>
      ))}
    </div>
  );
};
